import {AnyAction} from '@reduxjs/toolkit';

import {NON_CRITICAL_API_ENDPOINTS, TMeta, unavailableStatusSet} from './definitions';

const isMatchQueryMeta =
  (meta: TMeta) =>
  (action: AnyAction): action is AnyAction =>
    Object.entries(meta).every(([key, value]) => action.meta?.baseQueryMeta?.[key] === value);

const isMatchBackendUnavailableQuery = (action: AnyAction): action is AnyAction => {
  if (!action.meta?.baseQueryMeta?.isBackendError) {
    return false;
  }

  const isCriticalUrl = !NON_CRITICAL_API_ENDPOINTS.some(
    (url) => action.payload.config?.url === url,
  );

  return unavailableStatusSet.has(action.payload.status) && isCriticalUrl;
};

export {isMatchQueryMeta, isMatchBackendUnavailableQuery};
